module.exports = "https://coursera_assets.s3.amazonaws.com/images/e56effe2f98b28c5f498933c7ed52bed.png";